const MVP_NOTE_ID = "saasradar-mvp-prompt";

/**
 * Upsert a single SaaSRadar MVP prompt note (stable id) into project notes JSON.
 * Preserves legacy plain-text notes by wrapping them as one entry before merge.
 *
 * @param {string | null | undefined} previousNotes
 * @param {string} promptBody
 * @returns {string} JSON.stringify(entries)
 */
export function mergeMvpPromptIntoProjectNotes(previousNotes, promptBody) {
  const header = "--- SaaSRadar · MVP build prompt (paste into Base44 / Emergent / similar) ---\n\n";
  const text = `${header}${String(promptBody || "").trim()}`;

  let entries = [];
  const raw = previousNotes == null ? "" : String(previousNotes);
  if (raw.trim()) {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        entries = parsed.filter((e) => e && typeof e.text === "string" && e.text.trim().length > 0);
      }
    } catch {
      entries = [{ id: `legacy-${Date.now()}`, text: raw.trim(), created_at: new Date().toISOString() }];
    }
  }

  const without = entries.filter((e) => e.id !== MVP_NOTE_ID);
  without.unshift({
    id: MVP_NOTE_ID,
    text,
    created_at: new Date().toISOString(),
  });
  return JSON.stringify(without);
}
